<template>
  <div class="pdf service__request sr__listPage">
    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
      >
        <urn-repository-order
          v-if="form && form.formID && form.formID.name == 'Urn Repository Order'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <urn-repository-order-changi
          v-if="form && form.formID && form.formID.name == 'Urn Repository Order Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <urn-storage-request
          v-if="form && form.formID && form.formID.name == 'Request for Urn Repository For storage purpose only'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <urn-storage-request-changi
          v-if="form && form.formID && form.formID.name == 'Request for Urn Repository For storage purpose only Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <pedestal-installation-order
          v-if="form && form.formID && form.formID.name == 'Pedestal Installation Order'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <pedestal-installation-order-changi
          v-if="form && form.formID && form.formID.name == 'Pedestal Installation Order Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <ancestral-tablets-engraving
          v-if="form && form.formID && form.formID.name == 'Ancestral Tablets Engraving Notice'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <ancestral-tablets-engraving-changi
          v-if="form && form.formID && form.formID.name == 'Ancestral Tablets Engraving Notice Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <redemption-imported-urn
          v-if="form && form.formID && form.formID.name == 'Redemption of Imported Urn Form'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <redemption-imported-urn-changi
          v-if="form && form.formID && form.formID.name == 'Redemption of Imported Urn Form Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <redemption-of-urn
          v-if="form && form.formID && form.formID.name == 'Redemption of Urn from Niche / Ancestral Tablet From Pedestal'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <redemption-of-urn-changi
          v-if="form && form.formID && form.formID.name == 'Redemption of Urn from Niche / Ancestral Tablet From Pedestal Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <redemption-of-ornament
          v-if="form && form.formID && form.formID.name == 'Redemption of Ornament Form'"
          class="mt-2 pt-75"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <redemption-of-urn-return
          v-if="form && form.formID && form.formID.name == 'Redemption of Urn from Niche / Ancestral Tablet From Pedestal (Return to Company)'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <redemption-of-urn-return-changi
          v-if="form && form.formID && form.formID.name == 'Redemption of Urn from Niche / Ancestral Tablet From Pedestal (Return to Company) Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <urn-compartment-plaque-engraving
          v-if="form && form.formID && form.formID.name == 'Urn Compartment Plaque Engraving Notice'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <urn-compartment-plaque-engraving-changi
          v-if="form && form.formID && form.formID.name == 'Urn Compartment Plaque Engraving Notice Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <anling-chai-ling
          v-if="form && form.formID && form.formID.name == 'Anling / Chai Ling Form'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <anling-chai-ling-changi
          v-if="form && form.formID && form.formID.name == 'Anling / Chai Ling Form Changi'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
        <customer-feedback
          v-if="form && form.formID && form.formID.name == 'Customer’s Comment Form'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <request-form
          v-if="form && form.formID && form.formID.name == 'Request Form'"
          :digital-form="form.formID"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UrnRepositoryOrder from './UrnRepositoryOrder.vue'
import UrnStorageRequest from './UrnStorageRequest.vue'
import PedestalInstallationOrder from './PedestalInstallationOrder.vue'
import AncestralTabletsEngraving from './AncestralTabletsEngraving.vue'
import RedemptionOfUrn from './RedemptionOfUrn.vue'
import RedemptionOfOrnament from './RedemptionOfOrnament.vue'
import RedemptionImportedUrn from './RedemptionImportedUrn.vue'
import RedemptionOfUrnReturn from './RedemptionOfUrnReturn.vue'
import UrnCompartmentPlaqueEngraving from './UrnCompartmentPlaqueEngraving.vue'
import AnlingChaiLing from './AnlingChaiLing.vue'
import CustomerFeedback from './CustomerFeedback.vue'
import RequestForm from './RequestForm.vue'
import UrnRepositoryOrderChangi from '../form-templates-pdf-changi/UrnRepositoryOrder.vue'
import UrnStorageRequestChangi from '../form-templates-pdf-changi/UrnStorageRequest.vue'
import PedestalInstallationOrderChangi from '../form-templates-pdf-changi/PedestalInstallationOrder.vue'
import AncestralTabletsEngravingChangi from '../form-templates-pdf-changi/AncestralTabletsEngraving.vue'
import RedemptionImportedUrnChangi from '../form-templates-pdf-changi/RedemptionImportedUrn.vue'
import UrnCompartmentPlaqueEngravingChangi from '../form-templates-pdf-changi/UrnCompartmentPlaqueEngraving.vue'
import AnlingChaiLingChangi from '../form-templates-pdf-changi/AnlingChaiLing.vue'
import RedemptionOfUrnChangi from '../form-templates-pdf-changi/RedemptionOfUrn.vue'
import RedemptionOfUrnReturnChangi from '../form-templates-pdf-changi/RedemptionOfUrnReturn.vue'

export default {
  components: {
    BRow,
    BCol,

    UrnRepositoryOrder,
    UrnStorageRequest,
    PedestalInstallationOrder,
    AncestralTabletsEngraving,
    RedemptionImportedUrn,
    RedemptionOfUrn,
    RedemptionOfUrnReturn,
    UrnCompartmentPlaqueEngraving,
    AnlingChaiLing,
    CustomerFeedback,
    RedemptionOfOrnament,
    RedemptionOfUrnChangi,
    RedemptionOfUrnReturnChangi,
    RequestForm,
    UrnRepositoryOrderChangi,
    UrnStorageRequestChangi,
    PedestalInstallationOrderChangi,
    AncestralTabletsEngravingChangi,
    RedemptionImportedUrnChangi,
    UrnCompartmentPlaqueEngravingChangi,
    AnlingChaiLingChangi,
  },
  data() {
    return {
      topSpacing: 135,
      form: {},
      serviceRequest: {},
    }
  },
  beforeMount() {
    this.$http.get(`download/service-form/${this.$route.params.id}/show`)
      .then(response => {
        this.form = response.data.form || {}
        this.serviceRequest = response.data.sr || {}
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
}
</script>

<style>
.rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
}
@media print {
  div#app.semi-dark-layout {
    background: #fff !important;
  }

  .white-background {
    background: #fff !important;
  }
}
</style>
